<template>
    <div class="building" id="building">
        <template>
            <div class="build-animate">
                <div class="building-text" id="building-text">
                    <div class="building-text-wrap">
                        <span class="building-text-small">A New look on vibrant East Village</span>
                        <span class="building-text-intro">Introducing</span>
                        <br class="break">
                        <span class="image-wrapper">
                            <img id="titleImage" src="../assets/logo.svg" alt="Logo">
                        </span>
                    </div>
                    <span class="building-text-luxury">a luxury condominium landmark designed by Morris Adjmi.</span>
                </div>
                <img id="titleImage2" class="title-image-mobile" src="../assets/logo.svg" alt="Logo" :class="{ mobileImage: !showMobileImage}">
            </div>
            <span class="scrollDown">Scroll down</span>
            <info id="Info" :image="imagePath" :back-image="backImage"></info>
            <parallax
                :fixed="true"
                :sectionClass="isFixed ? 'changeSection' : undefined"
                :containerClass="isFixed ? 'changeSection2' : undefined"
            >
                <template v-for="(content, index) in descriptionContent">
                    <description
                        :key="index"
                        :description-title="content.title"
                        :description-body="content.text"
                        :image="content.image"
                        :image-width="content.imageWidth"
                        :class="'building-description-' + index">
                    </description>
                </template>
                <footer-part></footer-part>
            </parallax>
        </template>
    </div>
</template>

<script>
import Description from "../components/Description";
import Info from "../components/Info";
import Footer from "../layout/Footer";
import Parallax from 'vue-parallaxy';

export default {
  name: "Building.vue",
  data: () => ({
    isFixed: false,
    backImage: '',
    descriptionContent: [],
    imagePath: '',
    scrollPosition: 0,
    showMobileImage: false
  }),
  components: {
    Description,
    Info,
    'footer-part': Footer,
    Parallax
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
        fetch('/pages/building')
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                this.imagePath = data[0].image;
                this.descriptionContent = data.slice(1, data.length)
                if(window.innerWidth <= 600) {
                    this.backImage = this.imagePath
                } else {
                    this.backImage = ''
                }
            })
    },
    handleScroll () {

          const elmnt = document.getElementById("building");
          const y = elmnt.scrollTop;

          // mobile navigation image
          const screenWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
          // const screenHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
          const headImage = document.getElementById("titleImage");
          const menuMobile = document.getElementsByClassName('isBuilding')[0];
          if(screenWidth < 600) {
              if (y >= 44) {
                  headImage.classList.add("fixLogo")
                  menuMobile.classList.add("fixMenu")
                  this.$emit('isPass', true)
                  this.showMobileImage = false
              } else {
                  headImage.classList.remove("fixLogo")
                  menuMobile.classList.remove("fixMenu")
                  this.$emit('isPass', false)
                  this.showMobileImage = true
              }
          }

        if(window.innerHeight < 415 && window.innerWidth < 815) {
            if (y >= 0) {
                headImage.classList.add("fixLogo")
                menuMobile.classList.add("fixMenu")
                this.showMobileImage = false
            } else {
                headImage.classList.remove("fixLogo")
                menuMobile.classList.remove("fixMenu")
                this.$emit('isPass', false)
                this.showMobileImage = true
            }

            if (y >=44) {
                menuMobile.classList.add("fixMenuLandscape")
            } else {
                menuMobile.classList.remove("fixMenuLandscape")
            }
        }

          // text move
          const text = document.getElementById('building-text');
          const setStyle = text.style;
          setStyle.opacity = 1 - y/90;


          // navigation
          const info = document.getElementsByClassName("information")[0].offsetHeight;
          const showNavigation = y / info
          if(showNavigation > 0.9 ) {
              this.$emit('navOpacity', showNavigation / 1.3)
          } else {
              this.$emit('navOpacity', 0)
          }

          // scroll down
          const scrollDown = document.getElementsByClassName('scrollDown')[0];
          // const infoH = scrollDown.getBoundingClientRect().top
          const screenH = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

          if(((y + screenH) / info) > 1) {
              scrollDown.style.display = 'none'
          } else {
              scrollDown.style.display = 'block'
          }

          //Info
          const test = document.getElementById('Info').offsetHeight;

          if(y >= test) {
              this.isFixed = true
              this.$emit('setIndex', 10)
          } else {
              this.isFixed = false
              this.$emit('setIndex', null)
          }


          // Scroll fade
          let slides = document.getElementsByClassName("scrollFade");
          let slidesTitle = document.getElementsByClassName("scrollFadeText");
          let slidesBody = document.getElementsByClassName("scrollFadeBody");

          for (let i = 0; i < slidesTitle.length; i++) {
              let elPos = slidesTitle[i].getBoundingClientRect().top
              if(elPos < 60) {
                  slidesTitle[i].style.opacity = (elPos / 60)
              } else {
                  slidesTitle[i].style.opacity = 1
              }
          }

          for (let i = 0; i < slidesBody.length; i++) {
              let elPos = slidesBody[i].getBoundingClientRect().top
              if(elPos < 60) {
                  slidesBody[i].style.opacity = (elPos / 60)
              } else {
                  slidesBody[i].style.opacity = 1
              }
          }

        for (let i = 0; i < slides.length; i++) {
            let elPos = slides[i].getBoundingClientRect().top
            const elHeight = slides[i].offsetHeight
            const elPositionBottom = slides[i].getBoundingClientRect().bottom
            if(elPos < 0) {
                slides[i].style.opacity = ( elPositionBottom / elHeight)
            } else {
                slides[i].style.opacity = 1
            }
        }
      }
  },
  mounted () {
    document.getElementById('building').addEventListener('scroll', this.handleScroll);
    document.getElementById('building').addEventListener('resize', ()=> {
      if(window.innerWidth <= 600) {
        this.backImage = 'building.png'
      } else {
        this.backImage = ''
      }
    });
    document.getElementById('building').addEventListener('orientationchange', this.handleScroll);
  }

}
</script>

<style scoped lang="scss">
    .changeSection {
      height: 100% !important;

    }
    .changeSection2 {
      position: relative !important;
      height: auto !important;
    }
    .mobileImage {
        visibility: hidden;
    }
</style>
